import { IAccount, IStep } from 'src/types'
import { MutableRefObject, useMemo } from 'react'
import { JourneyMap } from 'src/components'
import { PageTitle, PageWrapper } from '../fairtrade.styled'
import { RichDescription } from 'src/components'
import { Box, Typography } from '@mui/material'
import { FAIRTRADE_FONT_STACK } from '../constants'
import { FairtradeFonts } from '../fairtrade-fonts'
import { MapProvider } from 'src/contexts/journey-map.context'
import { FairtradeJourneySteps } from './fairtrade-journey-steps'
import { JOURNEY_PAGE_TEMPLATE_ID } from 'src/templates/constants'
import { useTranslation } from 'react-i18next'

interface IProps {
  steps: IStep[]
  account: IAccount
  topRef: MutableRefObject<HTMLSpanElement>
  scrollToRef: MutableRefObject<HTMLSpanElement>
  isImpacts: boolean
  accauntSimpleId: string
  journeyName?: string
  journeyDescription?: string
}

export const FairtradeJourneyTemplate = ({
  steps,
  account,
  topRef,
  scrollToRef,
  isImpacts,
  accauntSimpleId,
  journeyName,
  journeyDescription,
}: IProps) => {
  const [t] = useTranslation()

  const navBackground = useMemo(
    () => account?.alternative_color || '#DBFF4C',
    [account?.alternative_color],
  )

  const productLabel = t('journey-navigation-product-button')
  const impactsLabel = t('journey-navigation-impacts-button')
  const accountLabel = t('journey-navigation-account-button')

  const aboutAccountLabel = account?.account_holder
    ? `${accountLabel} ${account.account_holder}`
    : 'About this account'
  const nextLabel = isImpacts ? impactsLabel : aboutAccountLabel

  return (
    <PageWrapper>
      <FairtradeFonts />
      <span ref={topRef} />
      <PageTitle
        sx={{
          marginBottom: '10px',
          marginX: {
            xs: '24px',
            md: '8px',
          },
        }}
      >
        {t('journey-header-title')}
      </PageTitle>

      <MapProvider>
        <JourneyMap
          steps={steps}
          satelliteView={account.map_satellite_view}
          scrollToRef={scrollToRef}
          markerColor={account?.primary_color}
          isTopDivider={!!account?.alternative_color}
          isImpacts={isImpacts}
          accauntId={accauntSimpleId}
          navButtonsTopOffset={43}
          mapHeight="55vh"
          mapMaxHeight="450px"
          navVariant={JOURNEY_PAGE_TEMPLATE_ID.FAIRTRADE}
          prevLabel={productLabel}
          nextLabel={nextLabel}
          navBackgroundColor={navBackground}
          navTextColor="#111111"
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            marginX: {
              xs: '16px',
              lgs: '0px',
            },
          }}
        >
          {journeyName && (
            <Typography
              sx={{ mt: 4, fontSize: '24px', fontWeight: 600, fontFamily: FAIRTRADE_FONT_STACK }}
            >
              {journeyName}
            </Typography>
          )}

          <span ref={scrollToRef} />
          {journeyDescription && journeyDescription !== '<p><br></p>' && (
            <RichDescription
              html={journeyDescription}
              sx={{ mt: 4, fontFamily: FAIRTRADE_FONT_STACK }}
            />
          )}
          <FairtradeJourneySteps steps={steps} account={account} topRef={topRef} />
        </Box>
      </MapProvider>
    </PageWrapper>
  )
}
